import React, { useEffect, useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { API_BASE_URL, authHeaders } from "../../api";

function AdminUsers() {
    const [users, setUsers] = useState([]);
    const [newUser, setNewUser] = useState({ name: "", password: "", admin: false });
    const [status, setStatus] = useState("");

    const loadUsers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/users`, {
                headers: authHeaders()
            });
            const data = await response.json();
            setUsers(data.map((user) => ({ ...user, password: "" })));
        } catch (error) {
            console.error("Fehler beim Abrufen der Benutzer:", error);
        }
    };

    useEffect(() => {
        loadUsers();
    }, []);

    const updateUser = (index, field, value) => {
        setUsers((current) => current.map((user, userIndex) => (
            userIndex === index ? { ...user, [field]: value } : user
        )));
    };

    const createUser = async () => {
        setStatus("Legt Benutzer an...");

        try {
            const response = await fetch(`${API_BASE_URL}/api/createUser`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(newUser)
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || "Benutzer konnte nicht angelegt werden");
            }

            setNewUser({ name: "", password: "", admin: false });
            await loadUsers();
            setStatus("Benutzer angelegt");
        } catch (error) {
            console.error(error);
            setStatus(error.message);
        }
    };

    const saveUser = async (index) => {
        const user = users[index];
        setStatus("Speichert Benutzer...");

        try {
            const response = await fetch(`${API_BASE_URL}/api/users/${user.ID}`, {
                method: "PUT",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    name: user.name,
                    admin: user.Admin,
                    password: user.password
                })
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || "Benutzer konnte nicht gespeichert werden");
            }

            await loadUsers();
            setStatus("Benutzer gespeichert");
        } catch (error) {
            console.error(error);
            setStatus(error.message);
        }
    };

    const removeUser = async (user) => {
        setStatus("Löscht Benutzer...");

        try {
            const response = await fetch(`${API_BASE_URL}/api/users/${user.ID}`, {
                method: "DELETE",
                headers: authHeaders()
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || "Benutzer konnte nicht gelöscht werden");
            }

            await loadUsers();
            setStatus("Benutzer gelöscht");
        } catch (error) {
            console.error(error);
            setStatus(error.message);
        }
    };

    return (
        <div className="action-card">
            <h3>Benutzer</h3>
            <div className="action-card-body">
                <div className="cv-edit-item">
                    <div className="form-grid">
                        <label className="field-label" htmlFor="new-user-name">Name</label>
                        <input
                            id="new-user-name"
                            className="text-input"
                            value={newUser.name}
                            onChange={(event) => setNewUser((current) => ({ ...current, name: event.target.value }))}
                        />

                        <label className="field-label" htmlFor="new-user-password">Passwort</label>
                        <input
                            id="new-user-password"
                            className="text-input"
                            type="password"
                            value={newUser.password}
                            onChange={(event) => setNewUser((current) => ({ ...current, password: event.target.value }))}
                        />
                    </div>

                    <label className="check-row">
                        <input
                            type="checkbox"
                            checked={newUser.admin}
                            onChange={(event) => setNewUser((current) => ({ ...current, admin: event.target.checked }))}
                        />
                        Adminrechte
                    </label>

                    <button type="button" className="btn btn-secondary icon-label-button" onClick={createUser}>
                        <Plus size={18} />
                        Benutzer hinzufügen
                    </button>
                </div>

                {users.map((user, index) => (
                    <div className="cv-edit-item" key={user.ID}>
                        <div className="form-grid">
                            <label className="field-label" htmlFor={`user-name-${user.ID}`}>Name</label>
                            <input
                                id={`user-name-${user.ID}`}
                                className="text-input"
                                value={user.name}
                                onChange={(event) => updateUser(index, "name", event.target.value)}
                            />

                            <label className="field-label" htmlFor={`user-password-${user.ID}`}>Neues Passwort</label>
                            <input
                                id={`user-password-${user.ID}`}
                                className="text-input"
                                type="password"
                                value={user.password}
                                onChange={(event) => updateUser(index, "password", event.target.value)}
                                placeholder="Leer lassen, wenn unverändert"
                            />
                        </div>

                        <label className="check-row">
                            <input
                                type="checkbox"
                                checked={user.Admin}
                                onChange={(event) => updateUser(index, "Admin", event.target.checked)}
                            />
                            Adminrechte
                        </label>

                        <div className="admin-actions">
                            <button type="button" className="btn btn-success icon-label-button" onClick={() => saveUser(index)}>
                                <Save size={18} />
                                Speichern
                            </button>
                            <button type="button" className="btn btn-outline-danger icon-label-button" onClick={() => removeUser(user)}>
                                <Trash2 size={18} />
                                Entfernen
                            </button>
                        </div>
                    </div>
                ))}

                {status && <span className="save-status">{status}</span>}
            </div>
        </div>
    );
}

export default AdminUsers;
